import { StationNavigator } from '@app/components/base/stations/StationNavigator';
import { LiveDot } from '@app/components/playback/LiveDot';
import { useVideoStations } from '@app/core/stations/hooks/useVideoStations';
import { LivePlayerMuteControl } from '@app/features/global-live-player/components/LivePlayerMuteControl';
import { StationClock } from '@app/features/global-live-player/components/StationClock';
import { Station } from '@mi-front/core';
import { Box } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { LivePlayerScreenFullscreenControl } from './LivePlayerScreenFullscreenControl';

/**
 * Header for the dedicated live player screen. Shows station switcher (navigates to
 * /live-player/:slug on change), station clock, mute, fullscreen. No back, drag handle, Close, or PiP.
 */
export function LivePlayerScreenHeader({ station }: { station: Station }) {
  const history = useHistory();
  const stations = useVideoStations();

  return (
    <Box display="flex" px={2} py={1} justifyContent="space-between" alignItems="center">
      <Box display="flex" alignItems="center" gap={2}>
        <LiveDot color="red" size={10} />
        <StationNavigator
          activeId={station.id}
          stations={stations}
          onSelectStation={(s) =>
            history.push(`/live-player/${s.slug}?fullscreen=true&autoplay=true`)
          }
          size={'medium'}
        />
        <StationClock size={'medium'} />
      </Box>
      <Box display="flex" alignItems="center" gap={1}>
        <LivePlayerMuteControl size={'medium'} />
        <LivePlayerScreenFullscreenControl size={'medium'} />
      </Box>
    </Box>
  );
}
